import { getVisibleAdminSections } from "./adminSectionAccess";

/**
 * Admin section ids that still route to AdminPlaceholderScreen (or an inline
 * "coming soon" panel) inside AdministrationHubScreen's renderSection switch.
 * Verified against src/components/admin/AdministrationHubScreen.js — re-check
 * that switch before removing an id from this set, since building out a
 * section there should make it visible here automatically.
 */
export const UNFINISHED_ADMIN_SECTION_IDS = Object.freeze([
  "roles",
  "projects",
  "materials",
  "estimates",
  "reports",
  "notifications",
  "offline",
  "integrations",
  "advanced",
]);

/**
 * Sections excluded from the unified Settings menu for reasons other than
 * being unfinished:
 * - "overview" is Administration's own internal launcher, superseded by the
 *   Settings hub's own overview.
 * - "help_learning" already has a dedicated entry point (the "?" Product
 *   Education affordance on Home) and is education content, not
 *   organization configuration.
 */
const EXCLUDED_FROM_SETTINGS_MENU = new Set([
  "overview",
  "help_learning",
  ...UNFINISHED_ADMIN_SECTION_IDS,
]);

const SETTINGS_CATEGORY_BY_SECTION_ID = Object.freeze({
  organization: "Organization",
  work_schedule: "Organization",
  branding: "Organization",
  invitations: "Organization",
  users: "Users & Access",
  roles: "Users & Access",
  trades: "Workforce & Payroll",
  classifications: "Workforce & Payroll",
  payroll_types: "Workforce & Payroll",
  payroll_settings: "Workforce & Payroll",
  payroll: "Workforce & Payroll",
  work_types: "Work & Time",
  invoices: "Billing & Documents",
  feature_flags: "CrewPilot",
  subscription: "CrewPilot",
  integrations: "Connections",
});

export const SETTINGS_CATEGORY_ORDER = Object.freeze([
  "Organization",
  "Users & Access",
  "Workforce & Payroll",
  "Work & Time",
  "Billing & Documents",
  "CrewPilot",
  "Connections",
  "System",
]);

export function getVisibleSettingsAdminSections(can) {
  return getVisibleAdminSections(can).filter(
    (section) => !EXCLUDED_FROM_SETTINGS_MENU.has(section.id),
  );
}

export function groupSettingsAdminSectionsByCategory(sections) {
  const groups = new Map();
  for (const section of sections) {
    const category = SETTINGS_CATEGORY_BY_SECTION_ID[section.id] || "System";
    if (!groups.has(category)) {
      groups.set(category, []);
    }
    groups.get(category).push(section);
  }
  return groups;
}
